import { ReflectionValue } from './reflection.value';

export class ReflectionValueDto {
    textAnswer: string;
    pathwayId: string | null;
    courseId: string;
    moduleId: string;

    constructor(data: ReflectionValue) {
        this.textAnswer = data.textAnswer;
        this.pathwayId = data.pathwayId;
        this.courseId = data.courseId;
        this.moduleId = data.moduleId;
    }
}
